
import React, {useState, useEffect} from 'react';
import image_faq from 'image/faq.png';
import {SectionTitle} from 'components/items';
import makeTitle from 'function/makeTitle.js';
import ic_plus from 'image/icon/ic_plus.svg';

// fb
import firebase from 'library/firebase-config';
import 'firebase/firestore';
const db = firebase.firestore();

const sectionTitle = [
  {
    text: "FACTORY",
    color: "defualt",
    break: false
  },{
    text: "FAQ",
    color: "main",
    break: true
  }
]

const COLLECTION = 'customer_faq';
const ServiceFaq = (props) => {
  const [faqList, setFaqList] = useState([]);
  const [nowId, setNowId] = useState('');

  useEffect(()=> {
    _get();
  }, [])

  const _get = async () => {
    const ref = await db.collection(COLLECTION).orderBy('timestamp', 'desc').limit(5).get();
    const result = [];
    ref.forEach(el => {
      if(el.id==='category') return
      result.push({
        ...el.data(),
        id: el.id
      })
    })
    setFaqList(result)
  }

  const handleListClick = (id) => {
    if(id === nowId){

      setNowId('');
    }else{

      setNowId(id);
    }

  }

  return (
    <section className={`ServiceFaq ${props.className}`}>
      <div className="con">
        <div className="section-left">
          <img src={image_faq} alt="faq"/>
        </div>
        <div className="section-right">
          <SectionTitle text = {makeTitle(sectionTitle)}  type = "left"/>
          <p className="section-text left">자주 묻는 질문들을 모아뒀습니다.</p>
          <ul className="wrap-faq">
            {faqList.map((el,index)=> {
              return  <li className={`faqList ${nowId===el.id ? 'active' : ''}`} key = {el.id} onClick={() => {handleListClick(el.id)}}>
                        <div className="wrap-title">
                          <p className='title'>0{index+1}. {el.title}</p>
                          <img src={ic_plus} alt="pluse"/>
                        </div>

                        <div className="wrap-contents">
                          <div>
                            <p className="category color-main">#{el.category}</p>
                            <p className='text'>{el.text}</p>
                          </div>
                        </div>
                      </li>
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default ServiceFaq;